import axios from 'axios'
import i18n from '../i18n';

export default {
    state: {
        museums: [],
        museumsFetched: false,
        museumsLoader: false,
        activeMuseum: null,
        activeMuseumTab: 0,
        newMuseumObj: {
            defaultLocale: "",
            defaultTitle: "",
            museumLocales: []
        },
        editMuseumObj: {
            defaultLocale: "",
            defaultTitle: "",
            museumLocales: []
        }
    },
    getters: {
        newMuseumObj: state => state.newMuseumObj
    },
    mutations: {
        getMuseums(state, museums) {
            state.museums = museums;
        },
        setMuseumsFetched(state, museumsFetched) {
            state.museumsFetched = museumsFetched;
        },
        toggleMuseumsLoader(state, museumsLoader) {
            state.museumsLoader = museumsLoader;
        },
        setActiveMuseum(state, museumId) {
            const found = state.museums.find(museum => museum.id == museumId);

            if (found) {
                state.activeMuseum = { ...found }
            }
        },
        setActiveMuseumTab(state, tab) {
            state.activeMuseumTab = tab;
        },
        setNewMuseumObject(state, museumObj) {
            state.newMuseumObj = museumObj;
        },
        setNewMuseumObjectProp(state, payload) {
            state.newMuseumObj[payload.prop] = payload.value;
        },
        setEditMuseumObject(state, museumObj) {
            state.editMuseumObj = museumObj;
        },
        setEditMuseumObjectProp(state, payload) {
            state.editMuseumObj[payload.prop] = payload.value;
        }
    },
    actions: {
        setNewMuseumObjectProp({ commit }, payload) {
            commit('setNewMuseumObjectProp', payload);
        },
        setEditMuseumObject({ commit }, museumObj) {
            commit('setEditMuseumObject', museumObj);
        },
        setEditMuseumObjectProp({ commit }, payload) {
            commit('setEditMuseumObjectProp', payload);
        },
        setActiveMuseum({ commit }, museumId) {
            commit('setActiveMuseum', museumId);
        },
        async getMuseums({ commit, state }, refresh = false) {
            if (state.museumsFetched && !refresh) return;

            commit("toggleMuseumsLoader", true);

            try {
                // get museum list with big size to bring them all
                // this call response is with paging
                const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/museums/list?size=1000`);

                commit("getMuseums", res?.data.content);
                commit("setMuseumsFetched", true);
            } catch (e) {
                throw e;
            }

            commit("toggleMuseumsLoader", false);
        },
        async addMuseum({ dispatch, commit }, museumObj) {
            try {
                const res = await axios.post(`${process.env.VUE_APP_BASE_URL}/museums/`, museumObj);

                const museum = res.data;

                await dispatch("getMuseums", true);

                commit("toggleSnackbar", {
                    text: `${i18n.t('addedPartner')}`,
                    color: "success",
                    open: true
                });

                return museum.id;
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async createUser({ state }, user) {
            try {
                await axios.post(`${process.env.VUE_APP_BASE_URL}/users/`, {
                    ...user,
                    museumId: state.activeMuseum.id
                });
            } catch (e) {
                throw e;
            }
        },
        async editMuseum({ state }) {
            let payload = {
                defaultLocale: state.editMuseumObj.defaultLocale,
                defaultTitle: state.editMuseumObj.defaultTitle,
                locales: state.editMuseumObj.museumLocales.map((el) => {
                    return {
                        locale: el.locale,
                        title: el.title
                    }
                })
            };
            try {
                const res = await axios.put(`${process.env.VUE_APP_BASE_URL}/museums/${state.activeMuseum.id}`, payload);
            } catch (e) {
                throw e;
            }
        },
        async deleteMuseum({ commit }, museumId) {
            try {
                await axios.delete(`${process.env.VUE_APP_BASE_URL}/museums/${museumId}`);
                commit("toggleSnackbar", {
                    open: true,
                    color: "success",
                    text: i18n.t('museumDeleted')
                })
            } catch (e) {
                throw e;
            }
        },
        async deleteProgram({ commit }, programId) {
            try {
                await axios.delete(`${process.env.VUE_APP_BASE_URL}/programs/${programId}`);
                commit("toggleSnackbar", {
                    open: true,
                    color: "success",
                    text: i18n.t('programDeleted')
                })
            } catch (e) {
                throw e;
            }
        }
    },
}
